module.exports = __webpack_public_path__ + "img/Joboffer.b835853b.svg";